import { Theme } from "@mui/material";

export default function Typography(theme: Theme) {
    return {
        MuiTypography: {
            styleOverrides: {
                gutterBottom: {
                    marginBottom: 12
                }
            }
        }
    };
}
